// Dependencies
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import truncate from 'lodash.truncate';
import striptags from 'striptags';
import parse from 'html-react-parser';

// Components
import Container from '../../container/container';
import Modal from '../../modal/modal';

// Utilities
import slugify from '../../../utilities/slugify';

// Styles
import QaModalsStyles from './qaModals.styles';
import Image from '../../image/image';

export default function QaModals({ layout, isFirstLayout }) {
  const backgroundImage = layout?.backgroundImage;
  const heading = layout?.heading;
  const subheading = layout?.subheading;
  const qaModals = layout?.qAModals;

  const contentMaxCharCount = 175;

  const [currentModal, setCurrentModal] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const currentTeamMember = params?.question;
      setCurrentModal(currentTeamMember);
    }
  }, [setCurrentModal]);

  const handleOpenModal = (title) => {
    const modalId = slugify(title);

    setCurrentModal(modalId);

    if (typeof window !== 'undefined')
      window.history.replaceState({}, '', `?question=${modalId}`);
  };

  const handleCloseModal = () => {
    setCurrentModal(null);
  };

  return (
    <QaModalsStyles>
      <Image image={backgroundImage} backgroundColor="sand" background />

      <Container>
        {isFirstLayout ? (
          <>
            {heading && <h1 className="heading">{heading}</h1>}
            {subheading && <h2 className="subheading large">{subheading}</h2>}
          </>
        ) : (
          <>
            {heading && <h2 className="heading large">{heading}</h2>}
            {subheading && <h3 className="subheading">{subheading}</h3>}
          </>
        )}
      </Container>

      <Container>
        {qaModals && (
          <div className="qa-modals">
            {qaModals.map((qaModal) => {
              const title = qaModal?.title;
              const content = qaModal?.content;

              const strippedContent = striptags(content);
              const truncatedContent = truncate(strippedContent, {
                length: contentMaxCharCount,
                separator: ' ',
                omission: '...',
              });

              return (
                <div className="qa-modal" key={qaModal?.title}>
                  <h5 className="title">{title}</h5>

                  <div>{parse(truncatedContent)}</div>

                  {strippedContent.length > contentMaxCharCount && (
                    <>
                      {' '}
                      <button
                        className="btn text-only"
                        type="button"
                        onClick={() => handleOpenModal(title)}
                      >
                        Read More
                      </button>
                      <Modal
                        modalId={slugify(title)}
                        header={<h2 className="heading">{title}</h2>}
                        currentModal={currentModal}
                        handleClose={handleCloseModal}
                      >
                        {parse(content)}
                      </Modal>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </Container>
    </QaModalsStyles>
  );
}

QaModals.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    subheading: PropTypes.string,
    backgroundImage: PropTypes.shape({
      altText: PropTypes.string,
      gatsbyImage: PropTypes.shape({}),
    }),
    qAModals: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
  }),
  isFirstLayout: PropTypes.bool,
};

QaModals.defaultProps = {
  layout: {},
  isFirstLayout: false,
};
